import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function ModelPicker({ value, onChange, disabled }) {
  const [models, setModels] = useState([]);
  useEffect(() => { api.get("/chat/models").then((r) => setModels(r.data)).catch(() => {}); }, []);
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid="model-picker" className="w-[250px] rounded-sm h-9 text-sm">
        <SelectValue placeholder="Model" />
      </SelectTrigger>
      <SelectContent>
        {models.map((m) => (
          <SelectItem key={m.key} value={m.key} data-testid={`model-option-${m.key}`}>{m.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
